














































import { dateFormat } from '@/helpers/dateFormat';
import { parseStringToDate } from '@/helpers/dateUtils';
import DatePicker from 'v-calendar/lib/components/date-picker.umd';
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';

@Component({
  components: {
    DatePicker
  }
})
export default class UiDatePickerRange extends Vue {
  @Prop({
    default: ''
  })
  public label!: string;

  @Prop()
  public value!: any[];

  @Prop({
    default: null
  })
  public placeholder?: string;

  @Prop({
    default: ''
  })
  public height?: string;

  @Prop({
    default: false
  })
  public outline?: boolean;

  @Prop({
    default: false
  })
  public clearable?: boolean;
  @Prop({
    default: false
  })
  public loading?: boolean;
  @Prop({
    default: false
  })
  public disabled?: boolean;
  @Prop({
    default: false
  })
  public readonly?: boolean;

  @Prop({
    default: null
  })
  public rules?: any;

  @Prop({
    default: null
  })
  public min?: string;

  private dateMenu: boolean = false;

  private dateFormatted: any = null;
  private dates: string[] = [];

  private selectedDates: any = {};

  masksConfig = {
    title: 'MMMM "de" YYYY'
  };

  attrs = [
    {
      key: 'today',
      highlight: {
        fillMode: 'outline',
      },
      dates: new Date(),
    }
  ];

  @Watch('value')
  public onChangeValue(dates: string[]): void {
    this.dates = dates;
    if (!dates || dates.length < 2) {
      this.selectedDates = { start: null, end: null };
      this.dates = [null, null];
      return;
    }
    let d1 = this.formatDate(dates[0]);
    let d2 = this.formatDate(dates[1]);
    if (d1 != d2) {
      this.dateFormatted = `${d1} - ${d2}`;
    } else {
      this.dateFormatted = d1;
    }
    this.dateMenu = false;

    this.prepareSelectedDates(this.dates);
  }

  public beforeMount(): void {
    this.onChangeValue(this.value);
  }

  public onChangeDateFormatted(): void {
    let dSplit = this.dateFormatted.split(' - ');
    this.dates = [];
    if (dSplit.length < 1 || dSplit[0].length < 10) {
      this.dateFormatted = null;
      this.$emit('input', [null, null]);
      return;
    }
    this.dates.push(dateFormat(dSplit[0], 'US', 'DD/MM/YYYY', true));
    let indexD2 = 1;
    if (dSplit.length < 2 || dSplit[1].length < 10) {
      indexD2 = 0;
    }
    this.dates.push(dateFormat(dSplit[indexD2], 'US', 'DD/MM/YYYY', true));
    this.prepareSelectedDates(this.dates);
  }

  prepareSelectedDates(dates: string[]) {
    this.selectedDates = {
      start: parseStringToDate(dates[0], 'YYYY-MM-DD'),
      end: parseStringToDate(dates[1], 'YYYY-MM-DD')
    };
  }

  public handleClear(): void {
    this.$emit('input', [null, null]);
  }

  public onChangeSeletedDates(): void {
    if (!this.selectedDates || !this.selectedDates.start || !this.selectedDates.end) {
      return;
    }

    // somente data
    this.selectedDates.start = new Date(this.selectedDates.start.toDateString());
    this.selectedDates.end = new Date(this.selectedDates.end.toDateString());

    this.dates = [null, null];
    this.dates[0] = dateFormat(this.selectedDates.start, 'US', undefined, true);
    this.dates[1] = dateFormat(this.selectedDates.end, 'US', undefined, true);

    const calendar: any = this.$refs.calendar;
    calendar.move(this.selectedDates.start);

    this.$emit('input', this.dates);
    this.$emit('change', this.dates);
  }

  private formatDate(date: string): string {
    return !date ? '' : dateFormat(date, 'BR', undefined, true);
  }
}
